export const INVALID_DOCUMENT_ERROR = [
  "empty_document",
  "duplicate_checksum",
  "encrypted_pdf",
  "unreadable_pdf",
  "unconvertible_file",
] as const;

export type InvalidDocumentError = (typeof INVALID_DOCUMENT_ERROR)[number];
export type FailureReason = InvalidDocumentError | "unknown" | "unauthorized" | undefined;
